import Header from "./include/Header";
import Footer from "./include/Footer";
import {useContext, useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {Store} from "../Utils/Store";
import {ContactInfo as DefaultContactInfo} from "../Utils/Data";
import api from "../Utils/Axios";

function Base({children}) {
    const {pathname} = useLocation();

    const [appData, setAppData] = useState(null);
    const {state, dispatch} = useContext(Store);
    const {ContactInfo} = state

    useEffect(() => {
        // Ensure original contact info is always stored.
        dispatch({type: "SetContactInfo", payload: DefaultContactInfo});

        api
            .get("/application/")
            .then((res) => {
                setAppData(res.data);
                // Keep API data but prefer the original contact info values.
                const mergedContactInfo = {...res.data, ...DefaultContactInfo};
                dispatch({type: "SetContactInfo", payload: mergedContactInfo});
            })
            .catch((err) => {
                console.error("Failed to fetch application data:", err);
                // Fall back to the original contact info.
                dispatch({type: "SetContactInfo", payload: DefaultContactInfo});
            });
    }, [dispatch]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return (
        <>
            <div className="fix">
                <Header/>
                {children}
                <Footer/>
            </div>
        </>
    );
}

export default Base;
